// @flow
import React from 'react'
import utmLinkGenerator from '../../../../utils/UTMLinkGenerator'
import Loader from '../../../../utils/Loader'
import { unreadIndicator, unreadMessagesPlural } from '../../EmailUtils'
import Wrapper from './StyledWrapper'
import { LogoutLink, InboxLink, MessageLink } from './StyledLink'
import { Header, MailHeading, MailIcon, MailText, DivThemeColor, AddressContainer, InboxLinksContainer } from './StyledHeader'
import { type ComponentProps as Props } from '../../Types'

declare var STATICS_PATH: string

export default (props: Props) => {
  const {
    inbox: {
      summary: {
        unread = 0
      } = {},
      sender: {
        address
      } = {}
    } = {},
    widget: {
      meta: {
        logout = {},
        inbox = {}
      } = {},
      utmMedium
    },
    isLoading,
    handleLogoutClick
  } = props
  const inboxLink = utmLinkGenerator.createLink(inbox.location, { utmMedium })
  const messageLink = utmLinkGenerator.createLink(`${inbox.location || ''}?pg=newmsg`, { utmMedium })

  return (
    <Wrapper>
      { isLoading && <Loader/> }
      <Header>
        <MailHeading>
          <MailIcon src={`${STATICS_PATH}images/email/mail-icon-volny.png`} alt='Volný.cz Mail'/>
          Volný.cz Mail
        </MailHeading>
        <MailText>
          Dobrý den,<br/>
          máte <DivThemeColor>{ unreadIndicator(unread) }</DivThemeColor> { unreadMessagesPlural(unread) }.
        </MailText>
        <LogoutLink
          href={logout.location}
          onClick={event => {
            event.preventDefault()
            handleLogoutClick(event)
          }}>
          {logout.text}
        </LogoutLink>
        <AddressContainer>
          { address }
        </AddressContainer>
        <InboxLinksContainer>
          <InboxLink href={inboxLink}>Přejít do emailu</InboxLink>
          <MessageLink href={messageLink}>Nová zpráva</MessageLink>
        </InboxLinksContainer>
      </Header>
    </Wrapper>
  )
}
